/**
 * @hidden
 */
export var EMPTY_SELECTIONRANGE = { start: null, end: null };
//# sourceMappingURL=SelectionRange.js.map